import { mergeApplicationConfig, ApplicationConfig } from '@angular/core';
import { appConfig } from './app.config';

// Browser-specific config (no provideServiceWorker — custom media-sw.js handles caching)
const browserConfig: ApplicationConfig = {
  providers: [],
};

export const config = mergeApplicationConfig(appConfig, browserConfig);
